import cx from 'classnames';
import React from 'react';

type Props = {
  className?: string;
  accessibleLabel?: string;
  disabled?: boolean;
  children: React.ReactNode;
} & (
  | {
      as?: 'label';
      id: string;
    }
  | {
      as?: 'legend';
      id?: string;
    }
);

export const FieldLabel = ({
  id,
  as = 'label',
  accessibleLabel,
  className,
  children,
  disabled,
}: Props): JSX.Element => {
  return React.createElement(
    as,
    {
      className: cx(className, 'block mb-8 font-inter font-medium text-[13px] leading-[20px] ', {
        'text-black-38%': disabled,
      }),
      htmlFor: id,
      'aria-label': accessibleLabel,
    },
    children,
  );
};
